import { io, Socket } from 'socket.io-client';
import { useAuthStore } from '../store/authStore';

// Same origin as the REST API. socket.io is served at `/socket.io` by the
// Socket.IO-wrapped ASGI app (backend app.main:socket_app).
const API_URL = process.env.REACT_APP_API_URL || '';

let socket: Socket | null = null;

/** Lazily create the shared Socket.IO client. The auth callback re-reads the
 *  current access token on every (re)connect, so token refresh is transparent. */
export function getSocket(): Socket {
  if (socket) return socket;
  socket = io(API_URL || undefined, {
    path: '/socket.io',
    transports: ['websocket', 'polling'],
    auth: (cb) => cb({ token: useAuthStore.getState().token ?? '' }),
    reconnection: true,
  });
  return socket;
}

export function disconnectSocket(): void {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
